module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjkuNSIgY3k9IjkuNSIgcj0iOSIgZmlsbD0iI0M0QzRDNCIgZmlsbC1vcGFjaXR5PSIwLjI1IiBzdHJva2U9IiNDRkNGQ0YiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/x1.svg
// module id = OgZw
// module chunks = 1